import { Component } from '@angular/core';
import { ICmsClientModule } from '@icms/client/icms-client.module';

@Component({
    selector: 'error-500',
    templateUrl: 'error-500.html',
    imports: [ICmsClientModule]
})
export class Error500Component {}
